import { createSelector } from 'redux-orm';

import orm from '../orm';
import { getLatestArchivedRef } from '../utils/compute-card-points';

export const makeSelectHiddenPointAccrualsBadgeForCard = () =>
  createSelector(
    orm,
    (_, cardId) => cardId,
    ({ Card, Board, PointSystem, CardPointData, CardPointAdvancedData, CardPointArchivedData }, cardId) => {
      if (!cardId) {
        return null;
      }

      const cardModel = Card.withId(cardId);
      if (!cardModel) {
        return null;
      }

      const boardModel = Board.withId(cardModel.boardId);
      if (!boardModel || boardModel.isPointSystemEnabled === true) {
        return null;
      }

      const pointSystemModel = PointSystem.all()
        .filter({ boardId: cardModel.boardId })
        .first();

      if (!pointSystemModel) {
        return null;
      }

      const pointSystemId = pointSystemModel.id;

      const cardPointDataModel = CardPointData.all()
        .filter({ cardId, pointSistemId: pointSystemId })
        .first();

      const advancedItems = CardPointAdvancedData.all()
        .filter({ cardId, pointSistemId: pointSystemId })
        .toRefArray();

      let hasArchived = false;
      if (cardPointDataModel) {
        hasArchived =
          CardPointArchivedData.all().filter({ cpdId: cardPointDataModel.id }).toRefArray().length >
          0;
      }

      const hasAccruals = Boolean(cardPointDataModel) || advancedItems.length > 0 || hasArchived;
      if (!hasAccruals) {
        return null;
      }

      let templateName = '';
      if (cardPointDataModel) {
        const archivedModels = CardPointArchivedData.all()
          .filter({ cpdId: cardPointDataModel.id })
          .toModelArray();
        const latest = getLatestArchivedRef(archivedModels);
        if (latest?.sourceTemplateName) {
          templateName = latest.sourceTemplateName;
        }
      }

      if (!templateName && pointSystemModel.sourcePointSystemId) {
        const templateModel = PointSystem.withId(pointSystemModel.sourcePointSystemId);
        templateName = (templateModel && templateModel.name) || '';
      }

      return {
        templateName,
      };
    },
  );

export const selectHiddenPointAccrualsBadgeForCard = makeSelectHiddenPointAccrualsBadgeForCard();

export default {
  makeSelectHiddenPointAccrualsBadgeForCard,
  selectHiddenPointAccrualsBadgeForCard,
};
